
<template>
  <div class="topBg" ></div>
  <div class="loader" v-if="loading"></div>
  <div class="row  ">
      <div class="co-md-2"></div>
        <div class="d-lg-flex justify-content-around left-side">
         <div class="left-column">
          <div class="leave-container">
                <nav class="tab-bg">
                  <div class="nav nav-tabs " id="nav-tab" role="tablist">
                    <button class="leave-button1 nav-link active font-weight-bold " id="nav-leave-list-tab" data-bs-toggle="tab" data-bs-target="#nav-leave-list" type="button" role="tab" aria-controls="nav-leave-list" aria-selected="true" @click="tabSwitch('leave-list')">Leaves for Approval</button>
                    <button class="leave-button2 nav-link font-weight-bold " id="nav-assignedto-tab" data-bs-toggle="tab" data-bs-target="#nav-assignedto" type="button" role="tab" aria-controls="nav-assignedto" aria-selected="false" @click="tabSwitch('assignedto')">Apply on behalf of</button>
                  </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                   <!--Leave List-->
              <div class="tab-pane fade show active " id="nav-leave-list" role="tabpanel" aria-labelledby="nav-leave-list-tab">
                <div class="col-lg-12 leaveModal leave-list mobile-table">
                    <table class="table ">
                      <div class="no-announcement" v-if="this.leaveLength <= 0">
                        <img class="noAnnouncementImg" :src="noHolidayImg" alt="icons" >
                        <div class="mt-2" style="font-size: 20px"> There are no records!</div>
                      </div>
                      
                      <tr style="height: 54px;" v-for="(leaves,index) in pendingData" :key="index">
                        <td style="font-size: 12px;">
                          <p style="margin:0px;" class="mobileview-text">{{leaves.name}}</p>

                          <p style="margin:0px;" v-if="leaves.leave_type == 'Optional Leave'">Optional Public Leave</p>
                          <p style="margin:0px;" v-else>{{leaves.leave_type}}</p>

                          <p style="margin:0px;">{{leaves.start_date}} - {{leaves.end_date}}</p>
                          <p style="margin:0px;">{{leaves.num_of_days}} day(s)</p>
                          <p style="margin:0px;">{{leaves.duration_type}}</p>
                          <p style="margin:0px;text-transform: capitalize;">{{leaves.status}}</p>
                        </td>
                        <td>
                          <div class="" v-if="leaves.status == 'pending' && canActOnPendingLeave(leaves)">
                            <a style="text-decoration: underline;cursor: pointer" @click="approveLeave(leaves)"><span title="Approve" style="font-size: 30px !important;margin-right: 0px !important; color:orange;" class="mdi  " :class="'mdi-checkbox-outline mr-3'"></span></a>
                            <a style="text-decoration: underline;cursor: pointer" @click="rejectLeave(leaves)"><span title="Reject" style="font-size: 30px !important;color:red;" class="mdi  " :class="'mdi-close-box-outline'"></span></a>
                          </div>
                        </td>
                      </tr>
                      
                      <tr  style="height: 54px;" v-for="(leaves,index) in approvedData" :key="index">
                        <td style="font-size: 12px;">
                          <p style="margin:0px;" class="mobileview-text">{{leaves.name}}</p>
                          <p style="margin:0px;" v-if="leaves.leave_type == 'Optional Leave'">Optional Public Leave</p>
                          <p style="margin:0px;" v-else>{{leaves.leave_type}}</p>
                          <p style="margin:0px;">{{leaves.start_date}} - {{leaves.end_date}}</p>
                          <p style="margin:0px;">{{leaves.num_of_days}} day(s)</p>
                          <p style="margin:0px;">{{leaves.duration_type}}</p>
                          <p style="margin:0px;text-transform: capitalize;">{{leaves.status}}</p>
                        </td>
                        <td>
                          <div class="" v-if="this.permissions.includes('Leave-Admin') && leaves.status == 'Approved'">
                            <a style="text-decoration: underline;cursor: pointer" @click="revokeLeave(leaves)"><span title="Revoke" style="font-size: 30px !important;margin-right: 0px !important;" class="mdi  " :class="'mdi-arrow-left-bold-box-outline mr-3'"></span></a>
                            <a style="text-decoration: underline;cursor: pointer" @click="rejectLeave(leaves)"><span title="Reject" style="font-size: 30px !important;color:red;" class="mdi  " :class="'mdi-close-box-outline'"></span></a>
                          </div>

                          <span v-else-if="leaves.status == 'Approved'"
                            class="px-2 m-2 text-center mdi mdi-check-circle "
                            style="font-size: 30px;color: green;">
                          </span>

                          <span v-else-if="leaves.status == 'Rejected'"
                            class="px-2 m-2 text-center mdi mdi-check-circle"
                            style="font-size: 30px;color: green;">
                          </span>

                          <span v-else-if="leaves.status == 'Cancelled'"
                            class="px-2 m-2 text-center mdi mdi-cancel"
                            style="font-size: 30px;color: red;">
                          </span>
                        </td> 
                      </tr>
                  </table>
                </div>


             <!-- tab view start-->

               <div class="col-lg-12 leaveModal leave-list tab-table">
                    <table class="table ">
                     <div class="no-announcement" v-if="this.leaveLength <= 0">
                        <img class="noAnnouncementImg" :src="noHolidayImg" alt="icons" >
                        <div class="mt-2" style="font-size: 28px" > There are no records!</div>
                      </div>
                       
                      <tr style="height: 54px;" v-for="(leaves,index) in pendingData" :key="index">
                        <td style="font-size: 22px;">
                          <p style=" margin:0px;" class="tabview-text">{{leaves.name}}</p>

                          <p style="margin:0px;" v-if="leaves.leave_type == 'Optional Leave'">Optional Public Leave</p>
                          <p style="margin:0px;" v-else>{{leaves.leave_type}}</p>

                          <p style="margin:0px; ">{{leaves.start_date}} - {{leaves.end_date}}</p>
                          <p style="margin:0px; ">{{leaves.num_of_days}} day(s)</p>
                          <p style="margin:0px; ">{{leaves.duration_type}}</p>
                          <p style="margin:0px; text-transform: capitalize;">{{leaves.status}}</p>
                        </td>
                        <td>
                          <div class="" v-if="leaves.status == 'pending' && canActOnPendingLeave(leaves)">
                            <a style="text-decoration: underline;cursor: pointer" @click="approveLeave(leaves)"><span title="Approve" style="font-size: 45px !important;color:orange;" class="mdi  " :class="'mdi-checkbox-outline mr-3'"></span></a>
                            <a style="text-decoration: underline;cursor: pointer" @click="rejectLeave(leaves)"><span title="Reject" style="font-size: 45px !important;color:red;" class="mdi  " :class="'mdi-close-box-outline'"></span></a>
                          </div>
                        </td>
                      </tr>
                      
                      <tr  style="height: 54px;" v-for="(leaves,index) in approvedData" :key="index">
                        <td style="font-size: 22px;">
                          <p style=" margin:0px;" class="tabview-text">{{leaves.name}}</p>

                          <p style="margin:0px;" v-if="leaves.leave_type == 'Optional Leave'">Optional Public Leave</p>
                          <p style="margin:0px;" v-else>{{leaves.leave_type}}</p>

                          <p style="margin:0px;">{{leaves.start_date}} - {{leaves.end_date}}</p>
                          <p style="margin:0px;">{{leaves.num_of_days}} day(s)</p>
                          <p style="margin:0px;">{{leaves.duration_type}}</p>
                          <p style="margin:0px;text-transform: capitalize;">{{leaves.status}}</p>
                        </td>
                        <td>
                          <div class="" v-if="this.permissions.includes('Leave-Admin') && leaves.status == 'Approved'">
                            <a style="text-decoration: underline;cursor: pointer" @click="revokeLeave(leaves)"><span title="Revoke" style="font-size: 45px !important;" class="mdi  " :class="'mdi-arrow-left-bold-box-outline mr-3'"></span></a>
                            <a style="text-decoration: underline;cursor: pointer" @click="rejectLeave(leaves)"><span title="Reject" style="font-size: 45px !important;color:red;" class="mdi  " :class="'mdi-close-box-outline'"></span></a>
                          </div>

                            <span v-else-if="leaves.status == 'Approved'"
                            class="px-2 m-2 text-center mdi mdi-check-circle "
                            style="font-size: 40px;color: green;">
                          </span>

                          <span v-else-if="leaves.status == 'Rejected'"
                            class="px-2 m-2 text-center mdi mdi-check-circle"
                            style="font-size: 40px;color: green;">
                          </span>

                          <span v-else-if="leaves.status == 'Cancelled'"
                            class="px-2 m-2 text-center mdi mdi-cancel"
                            style="font-size: 40px;color: red;">
                          </span>
                        </td> 
                      </tr>
                  </table>
                </div>
<!-- tab view ends-->

                <div class="col-lg-12 leaveModal leave-list desktop-table">
                  <table id="teamTableDesktop" class="table" >
                     <div class="no-announcement" v-if="this.leaveLength <= 0">
                        <img class="noAnnouncementImg" :src="noHolidayImg" alt="icons" >
                        <div class="mt-2" style="font-size: 22px" > There are no records!</div>
                      </div>
                      <!-- <thead>
                          <tr class="text-center">
                              <th scope="col"></th>
                              <th scope="col"></th>
                              <th scope="col">Name</th>
                              <th scope="col" >Type</th>
                              <th scope="col">From</th>
                              <th scope="col">To</th>
                              <th scope="col">Days</th>
                              <th scope="col">Duration</th>
                              <th scope="col">Status</th>
                              <th scope="col">Attachment</th>
                              <th scope="col">Action</th>
                          </tr>
                      </thead> -->
                      <tbody></tbody>  
                    </table>
              </div>
            </div>  
           <!--leave List ends-->

             <!--Leave assigned to -->
              <div class="tab-pane fade" id="nav-assignedto" role="tabpanel" aria-labelledby="nav-assignedto-tab">
                 <div class="leave-holder">
                    <div class="row ml-2 d-flex">

                    <!--desktop view -->
                      <div class="col-6 mt-4 big-screen" style="padding-left: 10px;">
                          <div class="manager-name" style="display: inline">On behalf of <span style="font-size: 25px; color: red">*</span> &nbsp; : &nbsp;</div>
                          <select class="selected-leave" v-model="reportees" @change="getReporteesRegion($event)" >
                            <option value="" disabled selected>Select your option</option>
                            <option  v-for="(reportees,index) in directreportees"  :key="index" :value="reportees.empid">
                             <span>{{reportees.empid}} - {{reportees.name}}  </span>
                            </option>
                          </select>
                          
                          <div class="type-of-leave">Type of leave<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                          <select class="selected-leave" @change="getLeaveIdByType(appliedLeaveStatus.leaveCat)" v-model="appliedLeaveStatus.leaveCat">
                             <option value="" disabled selected>Select your option</option>
                             <option  v-for="(leavetype,index) in filterLeavesByRegion()"  :key="index">
                             <span>{{leavetype.name}}</span>
                             <span v-if="leavetype.balance != '' && leavetype.balance != null"> - {{leavetype.balance}}</span>
                            </option>
                          </select>
                          
                          <span class="auto-check">
                            <input v-if="(this.permissions.includes('Leave-Admin'))" type="checkbox" id="autoApproved"  v-model="toggleAutoApprove" class="autoApproved"/>
                           <label v-if="(this.permissions.includes('Leave-Admin'))" for="autoApproved" style="margin-left:1%;">Auto-Approved</label>
                          </span>

                           <div class=" leave-reason">Comments <span title="Click for help" style="color:red;cursor:pointer;" class="mdi mdi-help-circle-outline" v-on:click="helpcomment" ></span></div>
                            <textarea rows="3" maxlength="100" v-model="this.appliedLeaveStatus.reason" class="form-control reason" cols="0" > </textarea>

                            <div class="choose-file pt-1">Please choose file <span title="Click for help" style="color:red;cursor:pointer;" class="mdi mdi-help-circle-outline" v-on:click="helpattach" ></span>
                            </div>
                              <button @click="$refs.file.click()" class="" >choose file</button>
                              <img :src="fileLoaderImg" v-if="fileLoader" style="margin-left: 20px;" class="">
                            <div class="attach-files-text">{{this.medicalAttachment.name}}</div>
                            <!-- <div class="mt-1" style="color:red">Note: For more than one file do zip and upload</div> -->
                            <input type="file" id="file" ref="file" class="mt-2 pt-2" @change="uploadMedicalAttachment($event)" accept=".zip,.txt,text/plain,.rar,.7zip,application/pdf,application/msword,image/x-png,image/jpeg" style="display: none">

                      </div>


                      <div class="col-6 mt-4 big-screen">  
                        <div class="type-of-leave" style=" margin-top:0px;" >Duration<span style="font-size: 25px; color: red; font-weight: bold" >*</span></div>
                          <div @change="setSelectDateMin()">
                            <!-- Commented out First Half and Second Half options for desktop view -->
                            <!-- <label for="id1" v-if="leavename != 'Optional Leave' && leavename != 'Menstrual Cycle Leave'" class="ml-1"><input type="radio" v-model="appliedLeaveStatus.duration" name="option-desktop" id="id1" class="" value="First Half">First Half</label> -->
                            <!-- <label for="id2" v-if="leavename != 'Optional Leave' && leavename != 'Menstrual Cycle Leave'" class="ml-1"><input type="radio" v-model="appliedLeaveStatus.duration" name="option-desktop" id="id2"  class="" value="Second Half">Second Half</label> -->
                            <label for="id3" class="ml-1"><input type="radio" checked  v-model="appliedLeaveStatus.duration"  name="option-desktop" id="id3"  class="" value="Full Day">Full Day</label>
                          </div>
                          <div v-if="(this.leavename != 'Optional Leave' && appliedLeaveStatus.duration == 'Full Day')">
                            <div class="from-date" >From<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                            <input
                              type="date"
                              class="form-control from"
                              v-model="this.appliedLeaveStatus.from "
                              id="from"
                              autocomplete="off"
                              @change="getStartDate()"
                              required
                              />
                            <div class="to-date">To<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                            <input
                              type="date"
                              class="form-control to"
                              :min= "minToDate"
                              v-model="this.appliedLeaveStatus.to"
                              id="to"
                              autocomplete="off"
                              />
                          </div>
                          <div v-if="(this.leavename != 'Optional Leave' && appliedLeaveStatus.duration != 'Full Day')">
                              <div class="from-date" >Select Date<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                              <input
                                type="date"
                                class="form-control from select-date"
                                id="from"
                                autocomplete="off"
                                min=""
                                v-model="this.appliedLeaveStatus.from"
                                required
                                @change="halfDay()"
                                />
                          </div>
                       <!--optional leave -->
                       <div>
                          <div v-if="leavename == 'Optional Leave' && leavebal >= 1" class="type-of-leave">Optional Public Leave List<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                            <select class="optional-selected-leave" v-if="leavename == 'Optional Leave' && leavebal >= 1"  v-model="selectedOptionalLeaveDate" >
                              <option value="" disabled selected>Select your option</option>
                              <option  v-for="(leavetype,index) in optionalLeaveList" :key="index">
                              <span>{{leavetype.holidayname}} - ({{dateFormatter(leavetype.holidaydate)}})</span>  
                              </option>
                            </select>
                       </div>     
                          <!--optional leave ends-->
                            <button class="leave-apply"  @click="submit()">Apply</button>
                            <button class="leave-cancel" @click="clearLeaveData()">Clear</button> 
                      </div>
                      <!--desktop view ends-->


                      <!--mobile view start-->
                      
                      <div class="col-12 mobile-screen">
                          <div class="manager-name" style="display: inline">On behalf of <span style="font-size: 25px; color: red">*</span> &nbsp; : &nbsp;</div>
                          <select class="selected-leave" v-model="reportees" @change="getReporteesRegion($event)">
                            <option value="" disabled selected>Select your option</option>
                            <option  v-for="(reportees,index) in directreportees"  :key="index" :value="reportees.empid">
                             <span>{{reportees.empid}} - {{reportees.name}}  </span>
                            </option>
                          </select>

                          <div class="type-of-leave">Type of leave<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                          <select class="selected-leave" @change="getLeaveIdByType(appliedLeaveStatus.leaveCat)" v-model="appliedLeaveStatus.leaveCat">
                             <option value="" disabled selected>Select your option</option>
                             <option  v-for="(leavetype,index) in filterLeavesByRegion()"  :key="index">
                             <span>{{leavetype.name}}</span>
                             <span v-if="leavetype.balance != '' && leavetype.balance != null"> - {{leavetype.balance}}</span>
                            </option>
                          </select>

                          <div class="mobile-auto-approve">
                            <input v-if="(this.permissions.includes('Leave-Admin'))" type="checkbox" id="autoApproved" class="autoApproved" v-model="toggleAutoApprove" />
                            <label v-if="(this.permissions.includes('Leave-Admin'))" for="autoApproved" style="margin-left:1%;">Auto-Approved</label>
                          </div>


                          <div v-if="(this.leavename != 'Optional Leave' && appliedLeaveStatus.duration == 'Full Day')">
                            <div class="from-date" >From<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                            <input
                              type="date"
                              class="form-control from"
                              v-model="this.appliedLeaveStatus.from "
                              id="from"
                              autocomplete="off"
                               @change="getStartDate()"
                              required
                              />
                            <div class="to-date">To<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                            <input
                              type="date"
                              class="form-control to"
                              :min= "minToDate"
                              v-model="this.appliedLeaveStatus.to"
                              id="to"
                              autocomplete="off"
                              />
                          </div>

                          <div v-if="(this.leavename != 'Optional Leave' && appliedLeaveStatus.duration != 'Full Day')">
                              <div class="from-date" >Select Date<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                              <input
                                type="date"
                                class="form-control from select-date"
                                id="from"
                                autocomplete="off"
                                min=""
                                v-model="this.appliedLeaveStatus.from"
                                required
                                @change="halfDay()"
                                />
                          </div>
                          

                           <!--optional leave -->
                          <div>
                              <div v-if="leavename == 'Optional Leave' && leavebal >= 1" class="type-of-leave">Optional Public Leave List<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                                <select class="optional-selected-leave" v-if="leavename == 'Optional Leave' && leavebal >= 1"  v-model="selectedOptionalLeaveDate" >
                                  <option value="" disabled selected>Select your option</option>
                                  <option  v-for="(leavetype,index) in optionalLeaveList" :key="index">
                                  <span>{{leavetype.holidayname}} - ({{dateFormatter(leavetype.holidaydate)}})</span>  
                                  </option>
                                </select>
                          </div>     

                          <div class="type-of-leave">Duration<span style="font-size: 25px; color: red; font-weight: bold">*</span></div>
                          <div @change="setSelectDateMin()">
                            <!-- Commented out First Half and Second Half options -->
                            <!-- <label for="id1" v-if="leavename != 'Optional Leave' && leavename != 'Menstrual Cycle Leave'" class="ml-1"><input type="radio" v-model="appliedLeaveStatus.duration" name="option" id="id1" class="" value="First Half">First Half</label> -->
                            <!-- <label for="id2" v-if="leavename != 'Optional Leave' && leavename != 'Menstrual Cycle Leave'" class="ml-1"><input type="radio" v-model="appliedLeaveStatus.duration" name="option" id="id2"  class="" value="Second Half">Second Half</label> -->
                            <br class="line-break" style="display: block">
                            <label for="id3" class="ml-1"><input type="radio" checked v-model="appliedLeaveStatus.duration"  name="option" id="id3"  class="" value="Full Day">Full Day</label>
                          </div>


                          <div class=" leave-reason">Comments <span title="Click for help" style="color:red;cursor:pointer;" class="mdi mdi-help-circle-outline" v-on:click="helpcomment" ></span></div>
                          <textarea rows="3" maxlength="100" v-model="this.appliedLeaveStatus.reason" class="form-control reason" cols="0" > </textarea>  
                      

                          <div class="choose-file pt-1">Please choose file <span title="Click for help" style="color:red;cursor:pointer;" class="mdi mdi-help-circle-outline" v-on:click="helpattach" ></span></div>
                            <button @click="$refs.file.click()" class="choose-file-text" >choose file</button> 
                            <img :src="fileLoaderImg" v-if="fileLoader" style="margin-left: 20px;"> 
                          <div class="">{{this.medicalAttachment.name}}</div>
                          <!-- <div class=" note-text" style="color:red">Note: For more than one file do zip and upload</div> -->
                          <input type="file" id="file" ref="file" class="mt-2 pt-2" @change="uploadMedicalAttachment($event)" accept=".zip,.txt,text/plain,.rar,.7zip,application/pdf,application/msword,image/x-png,image/jpeg" style="display: none">


                          <div class="">
                            <button class="leave-apply"  @click="submit()">Apply</button>
                            <button class="leave-cancel" @click="clearLeaveData()">Clear</button> 
                           </div>

                      </div>
                      <!--mobile view ends-->

                    </div>
                  </div>
                </div>               

            </div> 
           <!--Leave assigned to ends -->
          </div> 
           </div>
        </div>
    </div>
    <div class="co-md-2"></div>

</template>

<script>
import $ from 'jquery';
import { decryptData } from '../js/utils/encrypt';
import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import noHoliday from '../assets/noHoliday.png';
import fileLoader from '../assets/spinner.gif';
import { getGlobalToken } from '@/js/utils/interceptor';


export default {
components: {

  },
  
  data(){
  const originalLeaveData = [
    {leaveType: 'Annual Leave', gender: 'All', region: ['All']},
    {leaveType: 'Sick Leave', gender: 'All', region: ['All']},
    {leaveType: 'Optional Leave', gender: 'All', region: ['IN']},
    {leaveType: 'Compensatory Leave', gender: 'All', region: ['All']},
    {leaveType: 'Marriage Leave', gender: 'All', region: ['All']},
    {leaveType: 'Bereavement Leave', gender: 'All', region: ['All']},
    {leaveType: 'Maternity Leave', gender: 'FEMALE',region: ['All']},
    {leaveType: 'Paternity Leave', gender: 'MALE', region: ['All']},
    {leaveType: 'Childcare Leave', gender: 'All', region: ['SG']},
    {leaveType: 'Carers Leave', gender: 'All', region: ['AU']},
    {leaveType: 'National Service Leave', gender: 'All', region: ['SG']},
    {leaveType: 'Hospital Leave', gender: 'All', region: ['SG']},
    {leaveType: 'Emergency Leave', gender: 'All', region: ['All']},
    {leaveType: 'Unpaid Leave', gender: 'All', region: ['All']},
    {leaveType: 'Menstrual Cycle Leave', gender: 'FEMALE', region: ['All']},
    {leaveType: 'Work From Home', gender: 'All', region: ['All']},
  ];
      return{   
       toggleAutoApprove: true,
       fileLoaderImg: fileLoader,
       fileLoader: false,
       permissions: [],  
       loading: false,    
       noHolidayImg: noHoliday,
         employeeId: '',
         whoAppliedLeaveData: '',
         selectedEmpRegion: '',
          appliedLeaveData: [
              {leaveType: 'Annual Leave', region: ['All']},
              {leaveType: 'Sick Leave', region: ['All']},
              {leaveType: 'Optional Leave', region: ['IN']},
              {leaveType: 'Unpaid Leave', region: ['All']},
            ],
            originalLeaveData,
            leaveAdminAppliedLeaveData: [...originalLeaveData], // copy here
            filteredManagerAppliedLeaveData: [],
            reportees: '',
            appliedLeaveStatus: {
              leaveCat: '',
              from: '',
              reason: '',
              duration: 'Full Day',
              to: '',
              status: 'Approved',
              empId: this.reporteesId,
              leaveid: '',
              autoApproved: true,
              whoami: 'linemanager',
              applied_by: this.employeeId,
              action_by: this.employeeId,
              appliedEmployeeLocation: '',
              level2Approval: false,
              city: '',
              country: ''
            },
            reporteesId :'',
            reporteeIndex: '',
            directreportees: [],
            reporteesLeaveBal : [],
            todaysDate: '',
            formSubmitMsg: false,
            pendingData: [],
            approvedData: [],
            balance: true,
            isApplyLeaveBtnDisabled:false,
            isRadioBtnDisabled: false,
            isMedicalCertificateAttached: false,
            medicalAttachment: '',
            optionalLeaveList: [],
            selectedOptionalLeaveDate: '',
            leavename: '',
            leavebal: '',
            allLeaveList: [],
            leaveLength: '',
            whoami: 'linemanager',
            whoamiLocation: '',
            desktopTable: '',
            token: null,
            // helpques: false
      };
  },
  // watch: {
  //   reportees() {
  //     this.appliedLeaveStatus.empId = this.reportees.split('-')[0];
  //     let parts = this.reportees.split('-');
  //     if (parts.length > 2) {
  //         this.appliedLeaveStatus.empId = parts.slice(0, -1).join('-');
  //     }
  //     this.getUpcomingData(this.appliedLeaveStatus.empId);
  //   }
  // },
  watch: {
  reportees(newValue) {
    // console.log("newvalue",newValue);
    this.appliedLeaveStatus.empId = newValue; // directly assign
    this.getUpcomingData(this.appliedLeaveStatus.empId);
  }
},
  mounted(){
    // console.log('this is the token ' ,this.token);
  //   if (!token) {
  //   console.error('No auth token found in local storage');
  //   return;
  // }
    //Decrypting Permissions
    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(mkLocalData, secretPermissionKey);

    //Done for Leave Admin and Executive role
    if(this.permissions.includes('Leave-Admin')) {
       this.whoami = 'leaveadmin';
    } else if(this.permissions.includes('Executive')) {
      this.whoami = 'executive';
    }

    this.appliedLeaveStatus.whoami = this.whoami;

     let currentDate = new Date();
    if(currentDate.getDate() < 10){
      if(currentDate.getMonth()+1 < 10){
        this.appliedLeaveStatus.from = currentDate.getFullYear()+'-0'+ `${currentDate.getMonth()+1}` +'-0'+ currentDate.getDate();
      } else {
         this.appliedLeaveStatus.from = currentDate.getFullYear()+'-'+ `${currentDate.getMonth()+1}` +'-0'+ currentDate.getDate();
      }
    } else {
      if(currentDate.getMonth()+1 < 10){
        this.appliedLeaveStatus.from = currentDate.getFullYear()+'-0'+ `${currentDate.getMonth()+1}` +'-'+ currentDate.getDate();
      } else {
        this.appliedLeaveStatus.from = currentDate.getFullYear()+'-'+ `${currentDate.getMonth()+1}` +'-'+ currentDate.getDate();
      }
    }
    this.appliedLeaveStatus.to = this.appliedLeaveStatus.from;
     if(this.leavename != 'Optional Leave' && this.appliedLeaveStatus.duration == 'Full Day'){
        // $('.to').attr({'min': this.appliedLeaveStatus.from});
        // $('.from').attr({'min': this.appliedLeaveStatus.from})
        setTimeout(()=>{
            $('.to').attr({'min': this.appliedLeaveStatus.from});
            // $('.from').attr({'min': this.appliedLeaveStatus.from});
          },100);
      }
    const secretKey = process.env.KEY || 'myscecretkey';
    var encryptedEmployeeID = localStorage.getItem('EmployeeID');
    this.employeeId = decryptData(encryptedEmployeeID, secretKey).replace(/['"]+/g, '');
    
    this.mountedFunction();

    // Events For Datatable - Start
    $('#teamTableDesktop tbody').on('click', 'td.dt-control', function (e) {
        var tr = e.target.closest('tr');
        var row = this.desktopTable.row(tr);
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
        } else {
            // Open this row
            row.child(this.format(row.data())).show();
        }
    }.bind(this));

    $('#teamTableDesktop tbody').on('click', 'td.attachment', function (e) {
        var tr = e.target.closest('tr');
        var row = this.desktopTable.row(tr);
        this.downloadAttachment(row.data().medical_certificate);
    }.bind(this));

    $('#teamTableDesktop tbody').on('click', 'td div a.approve', function (e) {
        var tr = e.target.closest('tr');
        var row = this.desktopTable.row(tr);
        this.approveLeave(row.data());
    }.bind(this));

    $('#teamTableDesktop tbody').on('click', 'td div a.blocked', function () {
        this.blockedAction();
    }.bind(this));

    $('#teamTableDesktop tbody').on('click', 'td div a.reject', function (e) {
        var tr = e.target.closest('tr');
        var row = this.desktopTable.row(tr);
        this.rejectLeave(row.data());
    }.bind(this));

    $('#teamTableDesktop tbody').on('click', 'td div a.revoke', function (e) {
        var tr = e.target.closest('tr');
        var row = this.desktopTable.row(tr);
        this.revokeLeave(row.data());
    }.bind(this));
    // Events For Datatable - End
},
computed: {
minToDate() {
  return this.appliedLeaveStatus.from; // Set the minimum allowed date for "To" input
}
},
created() {
    // Retrieve token from localStorage when component is created
    this.token = localStorage.getItem('authToken');
    if (!this.token) {
      this.token = getGlobalToken(); // Get token from your interceptor function if not stored
      localStorage.setItem('authToken', this.token); // Store token in localStorage
    }
    // console.log('Token in Team.vue:', this.token);
  },
methods: {

  helpattach(){
              Swal.fire({
                html: '<p><span style="font-size: 18px !important;margin-right:10px;" ></span><span style="font-size: 18px !important">Attachments are necessary in following conditions '+ '</span></p><strong>India<span style="color: red">*</span> : </strong>' + '</span></p>*Medical certificate is mandatory if sick leave is taken for more than 2 days.</br> *Medical certificate is mandatory if sick leave is taken on monday or friday.' + '</span></p><strong>Singapore<span style="color: red">*</span> : </strong>' + '</span></p>*Medical certificate is mandatory for applying sick leave.' + '</span></p>*Attaching relevant document is mandatory for applying National Service leave.'   + '</span></p><strong>Rest of APAC<span style="color: red">*</span> : </strong>' + '</span></p>*Medical certificate is mandatory for applying sick leave.' + '</span></p><strong>Note: </strong>'  + '</span></p><strong><span style="color: red">*</span> Check APAC Leave Policy in Files section for more information </strong>' + '</span></p>*Accepted file formats: .zip, .txt, text/plain, .rar, .7zip, application/pdf, application/msword, image/x-png, image/jpeg' + '</span></p>*For more than one file kindly zip and attach. ',
              });
      },

      helpcomment(){
        Swal.fire({
          html: `<p><span style="font-size: 28px !important;margin-right:10px;" ></span><span style="font-size: 18px !important">Comments are necessary in following conditions </span></p><strong>Compensatory leave<span style="color: red">*</span> : </strong>Enter the extra date and time that you have worked.</span> </p> An example comment would be:</span> </p> Reason for Request: Late night installation at ____________ (clients name) or Required to be on client site on a non-working day because of project/task ____________ .</span></p><strong>Sick leave<span style="color: red">*</span> : </strong>Specify about the leave</span></p><strong><span style="color: red">*</span> Check APAC Leave Policy in Files section for more information </strong>`,
              });
      },

  // goToRoute(){
  //     this.$router.push('/home');
  //   },

    redirectToLogin() {
      // Redirect to login page
      window.location.href = '/';
    },


  format(d) {
      if(d.applied_by == null) {
        d.applied_by = '';
      }
      if(d.reason == null) {
        d.reason = '';
      }
      if(d.action_by == null) {
        d.action_by = '';
      }
      if(d.comments == null) {
        d.comments = '';
      }
      return (
        '<table class="table" style="margin: auto;width:95%; font-size:14px;background:#f0f0f0">' +
          '<thead>' +
              '<tr>' +
                  '<th>Applied By</th>' +
                  '<th>Applied Comments</th>' +
                  '<th>Action By</th>' +
                  '<th>Action Comments</th>' +
              '</tr>' +
          '</thead>' +
          '<tbody>' +
            '<tr>' +
                  '<td style="width:25%">'+d.applied_by+'</td>' +
                  '<td style="width:25%">'+d.reason+'</td>' +
                  '<td style="width:25%">'+d.action_by+'</td>' +
                  '<td style="width:25%">'+d.comments+'</td>' +
              '</tr>' +
          '</tbody>' +
        '</table>'
      );
  },
  setSelectDateMin(){
    if(this.appliedLeaveStatus.duration != 'Full Day'){
        // $('.select-date').attr({'min': this.appliedLeaveStatus.from});
      } else {
         $('.to').attr({'min': this.appliedLeaveStatus.from});
        // $('.from').attr({'min': this.appliedLeaveStatus.from})
      }
      
  },
  getStartDate(){
    $('.to').attr({'min': this.appliedLeaveStatus.from});
    let fromdt =  new Date(this.appliedLeaveStatus.from);
    let todt =  new Date(this.appliedLeaveStatus.to);
    if(fromdt > todt) {
      this.appliedLeaveStatus.to = this.appliedLeaveStatus.from;
    }
    
  },
  halfDay(){
    this.appliedLeaveStatus.to = this.appliedLeaveStatus.from; 
  },
  
   dateFormatter(date){
      let finalDate = new Date(date);
      let month = finalDate.getMonth() + 1; 
      let currentdate = finalDate.getDate();
      if(month<10){
        month = '0'+month;
      }
      if(currentdate < 10){
        currentdate = '0' + currentdate;
      }
      return currentdate + '-' + month + '-' + finalDate.getFullYear();
    },
   uploadMedicalAttachment(event){
     this.fileLoader = true; 
      let url = event.target.files[0];
        if(url.size > 1024 * 1024) {
          event.preventDefault();
          this.fileLoader = false; 
          alert('File too big (> 1MB)');
          return;
      } else {
        this.isMedicalCertificateAttached = true;
        this.medicalAttachment = url;
        this.fileLoader = false; 
      }
    },
getUpcomingData(empid) {
  // this.loading = true;
  axios.post(this.$hostName + '/myInfo', {fetchType: 'upcoming', year: new Date().getFullYear(), empId: empid})
    .then((response) => {
      // let result = response.data[3];
      this.upcomingHolidays = response.data[3].upcomingHolidayData;
      this.appliedLeaveStatus.appliedEmployeeLocation = response.data[0].employeeData[0].location;
      this.appliedLeaveStatus.city = response.data[0].employeeData[0].city;
      this.appliedLeaveStatus.country = response.data[0].employeeData[0].location;
    })
    .catch((error) => {
      console.log(empid, error);
    })
    .finally(() => {
      // this.loading = false;
    });
 },
 async submit(){
    
    let id = '';
    this.balance = true;
    this.appliedLeaveStatus.empId = this.reportees;
    this.appliedLeaveStatus.applied_by = this.employeeId;
    this.appliedLeaveStatus.action_by = this.employeeId;

    let blockedHolidays = {};
      let onlyPublicHolidays = {};
      let onlyPublicHolidaysRange = [];
      for(let each in this.upcomingHolidays) {
        if(this.upcomingHolidays[each][0]["type"] == "public") {
          onlyPublicHolidays[each] = this.upcomingHolidays[each];
        }
      }
      
      if(this.leavename == ''){
          Swal.fire({
                text: 'Please select leave type',
                confirmButtonText: 'Ok',
              });
              this.loading = false;
              return;
      } else if(this.leavename.trim() == 'Sick Leave' && this.appliedLeaveStatus.reason == ''){
          Swal.fire({
                text: 'Please enter comments',
                confirmButtonText: 'Ok',
              });
              this.loading = false;
              return;
      } else if(this.leavename.trim() == 'Optional Leave' &&  this.selectedOptionalLeaveDate == ''){
          Swal.fire({
                text: 'Please select Optional Public leave',
                confirmButtonText: 'Ok',
              });
              this.loading = false;
              return;
      }
      else if(this.leavename.trim() != 'Menstrual Cycle Leave' && this.medicalAttachment == ''){
          Swal.fire({
                text: 'Please choose file',
                confirmButtonText: 'Ok',
              });
              this.loading = false;
              return;
      }

      let appliedDatesRange = [];

      let currentDate, toDate;

      if(this.leavename.trim() != "Optional Leave") {
        currentDate = new Date(this.appliedLeaveStatus.from);
        toDate = new Date(this.appliedLeaveStatus.to);
      } else if(this.leavename.trim() == "Optional Leave") {
        let optionalDate = this.selectedOptionalLeaveDate.match(/\(.*\)/)[0].slice(1, -1).split('-');
        let optionalDateString = optionalDate[2] + '-' + optionalDate[1] + '-' + optionalDate[0];
        currentDate = new Date(optionalDateString);
        toDate = new Date(optionalDateString);
        // console.log('from:', [currentDate, toDate]);
      }

      for (let each in onlyPublicHolidays) {
        let eachDate = new Date(each);
        let nextDate = new Date(each);
        let prevDate = new Date(each);

        let currentYear = currentDate.getFullYear();

        eachDate.setFullYear(currentYear);
        nextDate.setFullYear(currentYear);
        prevDate.setFullYear(currentYear);
        

        if(eachDate.getDay() == 1) {
          prevDate.setDate(prevDate.getDate()-3);
          nextDate.setDate(nextDate.getDate()+1);
        } else if(eachDate.getDay() == 5) {
          prevDate.setDate(prevDate.getDate()-1);
          nextDate.setDate(nextDate.getDate()+3);
        } else {
          nextDate.setDate(nextDate.getDate()+1);
          prevDate.setDate(prevDate.getDate()-1);
        }
        
        // prevDate.setDate(currentDate.getDate()-1);
        blockedHolidays[prevDate.toLocaleString(undefined, { month: "long", day: "2-digit" })] = onlyPublicHolidays[each];
        blockedHolidays[nextDate.toLocaleString(undefined, { month: "long", day: "2-digit" })] = onlyPublicHolidays[each];
        onlyPublicHolidaysRange.push(prevDate.toLocaleString(undefined, { month: "long", day: "2-digit" }));
        onlyPublicHolidaysRange.push(nextDate.toLocaleString(undefined, { month: "long", day: "2-digit" }));
      }

      for(let i = 0; currentDate <= toDate; i++) {
        appliedDatesRange.push(currentDate.toLocaleString('en-US', { month: 'long', day: '2-digit' }));
        currentDate.setDate(currentDate.getDate()+1);
      }

      if(this.leavename.trimEnd() == "Annual Leave" && this.whoami !== "leaveadmin") {
        for(let each of onlyPublicHolidaysRange) {
          if(appliedDatesRange.includes(each)) {
            Swal.fire({
              text: `As per company policy an employee can not apply for a leave before and/or after a public holiday.`,
              confirmButtonText: "Ok",
            });
            this.loading = false;
            return;
          }
        }
      }


      this.balance = true;
      this.appliedLeaveStatus.leaveCat = this.leavename.trim();
      if(this.appliedLeaveStatus.leaveCat == 'Optional Leave'){
        let optionalLeaveDate = this.selectedOptionalLeaveDate.split('- (')[1].replace(')', '');
        let date = optionalLeaveDate.split('-')[0];
        let month = optionalLeaveDate.split('-')[1];
        let year = optionalLeaveDate.split('-')[2];
        let finalDate = year + '-' + month + '-' + date;
        this.appliedLeaveStatus.to = finalDate;
        this.appliedLeaveStatus.from = finalDate;
        // console.log('from:', this.appliedLeaveStatus.from);
        // console.log('to:', this.appliedLeaveStatus.to);
      }
      //Required for Leave admin with capability to submit leave either auto-approved or for approval- start
      if(this.permissions.includes('Leave-Admin')) {
       this.appliedLeaveStatus.autoApproved = this.toggleAutoApprove;
       this.appliedLeaveStatus.applied_by = this.employeeId;
       this.appliedLeaveStatus.action_by = this.employeeId;
       if(!this.toggleAutoApprove) {
        this.appliedLeaveStatus.status = 'pending';
        this.appliedLeaveStatus.applied_by = this.employeeId;
        this.appliedLeaveStatus.action_by = '';
       }
      } 
      //Required for Leave admin with capability to submit leave either auto-approved or for approval- end

      //Making auto-approval false when applying for different region employee
      if((this.whoami == 'linemanager') && (this.whoamiLocation.trim() != this.appliedLeaveStatus.appliedEmployeeLocation.trim())) {
        // console.log('leave:', this.leavename);
        if(this.leavename != 'Sick Leave' && this.leavename.trim() != 'Work From Home') {
          // console.log('leave:', this.leavename);
          this.appliedLeaveStatus.autoApproved = true;
          this.appliedLeaveStatus.status = 'Level 1 Approved';
          if(this.employeeId == 'SG001') {
            this.appliedLeaveStatus.status = 'Approved';
          }
          this.appliedLeaveStatus.applied_by = this.employeeId;
          this.appliedLeaveStatus.action_by = '';
        } else {
          this.appliedLeaveStatus.status = 'Approved';
        }
      }
      
      let requestObject = JSON.parse(JSON.stringify(this.appliedLeaveStatus));
      requestObject.whoami = this.whoami;
      if(this.appliedLeaveStatus.leaveCat == "Optional Leave") {
        requestObject.leaveCat = "Optional Leave";
      }

      this.loading = true;
      await axios.post(this.$hostName + '/leaveData', requestObject)
          .then((response) => {
            if(response.status == 200){
              const successMessage = requestObject.leaveCat === 'Work From Home' 
                ? 'Your request submitted successfully' 
                : 'Leave request submitted successfully';
              Swal.fire({
                text: successMessage,
                confirmButtonText: 'Ok',
              });
            }
            else if(response.status == 203) {
              Swal.fire({
                text: response.data,
                confirmButtonText: 'Ok',
              }); 
              this.balance = false;
              return false;
            }
            id = response.data.id;
          }).catch((error) => {
            console.log(error);
            Swal.fire({
              text: 'Something went wrong. Please try again later.', 
              confirmButtonText: 'Ok',
            });
            this.balance = false;
            return;
          })
          .finally(() => {
            this.loading = false;
          });
          if(!this.balance) {
            this.loading = false;
            return false;
          }
           if(this.isMedicalCertificateAttached == true){
              let formData = new FormData();
              formData.append('empId', this.appliedLeaveStatus.empId);
              formData.append('file', this.medicalAttachment);
              formData.append('id', id);
            await axios.post(this.$hostName + '/uploadMedicalCertificate', formData, {headers : {'Content-Type': 'multipart/form-data'}})
              .then((response) => {
                  console.log(response);
              }).catch((error) => {
                console.log(error);
              }).finally(() =>{
                this.loading = false;
              });
        }
              this.clearLeaveData();
              this.mountedFunction();
              this.tabSwitch('leave-list');
  },
    clearLeaveData(){
      this.appliedLeaveStatus.leaveCat = '';
      this.appliedLeaveStatus.reason = '';
      this.appliedLeaveStatus.duration = 'Full Day';
      this.editleave = false;
      this.selectedOptionalLeaveDate = '';
       this.medicalAttachment = '';
       this.reportees = '';
       this.fileLoader = false;
       let currentDate = new Date();
      if(currentDate.getDate() < 10){
        if(currentDate.getMonth()+1 < 10){
          this.appliedLeaveStatus.from = currentDate.getFullYear()+'-0'+ `${currentDate.getMonth()+1}` +'-0'+ currentDate.getDate();
        } else {
          this.appliedLeaveStatus.from = currentDate.getFullYear()+'-'+ `${currentDate.getMonth()+1}` +'-0'+ currentDate.getDate();
        }
      } else {
        if(currentDate.getMonth()+1 < 10){
          this.appliedLeaveStatus.from = currentDate.getFullYear()+'-0'+ `${currentDate.getMonth()+1}` +'-'+ currentDate.getDate();
        } else {
          this.appliedLeaveStatus.from = currentDate.getFullYear()+'-'+ `${currentDate.getMonth()+1}` +'-'+ currentDate.getDate();
        }
      }
      this.appliedLeaveStatus.to = this.appliedLeaveStatus.from;
     setTimeout(() =>{
        if(this.leavename != 'Optional Leave' && this.appliedLeaveStatus.duration == 'Full Day'){
           $('.to').attr({'min': this.appliedLeaveStatus.from});
            // $('.from').attr({'min': this.appliedLeaveStatus.from})
        }
      }, 100);
    },
 async mountedFunction(){

    let currentDate = new Date(); 
        if(currentDate.getDate() < 10){
        if(currentDate.getMonth()+1 < 10){
          this.appliedLeaveStatus.from = currentDate.getFullYear()+'-0'+ `${currentDate.getMonth()+1}` +'-0'+ currentDate.getDate();
        } else {
          this.appliedLeaveStatus.from = currentDate.getFullYear()+'-'+ `${currentDate.getMonth()+1}` +'-0'+ currentDate.getDate();
        }
      } else {
        if(currentDate.getMonth()+1 < 10){
          this.appliedLeaveStatus.from = currentDate.getFullYear()+'-0'+ `${currentDate.getMonth()+1}` +'-'+ currentDate.getDate();
        } else {
          this.appliedLeaveStatus.from = currentDate.getFullYear()+'-'+ `${currentDate.getMonth()+1}` +'-'+ currentDate.getDate();
        }
      }
        this.appliedLeaveStatus.to = this.appliedLeaveStatus.from;
        setTimeout(() =>{
          if(this.leavename != 'Optional Leave' && this.appliedLeaveStatus.duration == 'Full Day'){
             $('.to').attr({'min': this.appliedLeaveStatus.from});
            // $('.from').attr({'min': this.appliedLeaveStatus.from})
          }
        },100);
        this.medicalAttachment = '';
        this.appliedLeaveStatus.leaveCat = '';
        this.appliedLeaveStatus.reason = '';
        this.medicalAttachment = '';
        this.selectedOptionalLeaveDate = '';
        this.appliedLeaveStatus.duration = 'Full Day';
        this.leavename = '';

    this.loading = true;
    this.pendingData = [];
     this.approvedData = [];
      console.log('whoami:', this.whoami);
      axios.post(this.$hostName + '/getOptionalLeaves', {whoami: this.whoami}).then((response)=>{
          this.optionalLeaveList = response.data[0].optionalLeaveData;
        });
    await axios.post(this.$hostName + '/getManagerDirectReportees', {empid: this.employeeId, whoami: this.whoami})
      .then((response) => {
        this.directreportees = response.data[1].directReportsData;
        this.reporteesLeaveBal = response.data[2];
        this.whoamiLocation = response.data[0].employeeData[0].location;
        }).catch((error) => {
          console.log(error);
        })
        .finally(() => {
        });
          this.reportees = '';
          axios.post(this.$hostName + '/getEmployeeReportingManager', { empid: this.employeeId, whoami: this.whoami })
    .then((response) => {
      // console.log('reportees are',this.directreportees);
      this.allLeaveList = response.data.data;
        // let totalRecords = response.data.recordsFiltered;
        // console.log('Total records:', totalRecords);
        // console.log('initial data coming from backend', this.allLeaveList);
     this.leaveLength = Object.keys(this.allLeaveList).length;
      for(let i=0; i<this.allLeaveList.length; i++){
        if(this.allLeaveList[i].status == 'pending' || this.allLeaveList[i].status == 'Level 1 Approved '){                           
          this.pendingData.push(this.allLeaveList[i]);
        } else if(this.allLeaveList[i].status == 'Approved' || this.allLeaveList[i].status == 'Rejected' || this.allLeaveList[i].status == 'Cancelled'){
          this.approvedData.push(this.allLeaveList[i]);
        }
      }

      // this.directreportees.forEach((r, i) => console.log(`Reportee ${i + 1}:`, r));
      var role = this.permissions;
      // var $this = this;
      let dataForTable = [];
      if(this.employeeId == 'SG001' || this.whoami == 'executive') {
        // dataForTable = response.data.filter(ele => ele.status != 'pending' && ele.level_2_approval == true);
          this.allLeaveList.forEach((ele) => {
          if((ele.reporting_to !== 'SG001') && (ele.status != 'pending')) {
            dataForTable.push(ele);
          } else if(ele.status == 'pending' && (ele.reporting_to == 'SG001')) {
            dataForTable.push(ele);
          }  else if(ele.status != 'pending' && (ele.reporting_to == 'SG001')) {
            dataForTable.push(ele);
          }
          // if(ele.status == 'Level 1 Approved') {
          //   dataForTable.push(ele);
          // } else {}
        });
        // dataForTable = response.data;
      } else {
        dataForTable = this.allLeaveList;
      }
      // const url = this.$hostName + '/getEmployeeReportingManager';
      // console.log('URL:', url); 
      this.desktopTable = $('#teamTableDesktop').DataTable({
  responsive: true,
  destroy: true,
  serverSide: true,
  processing: true,
  ajax: {
    url: this.$hostName + '/getEmployeeReportingManager',
    method: 'POST',
    headers: {
            'Authorization': `Bearer ${this.token}`
        },
    data: function (d) {
      // Include additional parameters if needed
      d.whoami = this.whoami;
      d.empid = this.employeeId;
      // console.log('Data being sent to server:', d); // Debugging log
      return d; // Make sure to return the data object
    }.bind(this),
    dataSrc: function (json) {
      // console.log('Data received from server:', json); // Debugging log
      return json.data;
    },
    error: function (xhr, error, code) {
          console.error('Error occurred:', error, 'Code:', code, 'Response:', xhr.responseText);
          if (xhr.status === 401) {
            // Handle token expiration: Redirect to login page
            this.redirectToLogin();
          }
        }.bind(this)
      },
  language: {
    searchPlaceholder: 'Enter text to search'
  },
  aaSorting: [],
  columns: [
    { data: 'id' },
    {
      className: 'dt-control',
      orderable: false,
      data: null,
      defaultContent: '',
    },
    { data: 'name', title: 'Name' },
    {
      data: 'leave_type',
      title: 'Type',
      render: function(data) {
        return data.trim() === 'Optional Leave' ?
          `<span>Optional Public Leave</span>` :
          `<span>${data}</span>`;
      }
    },
    { data: 'start_date', title: 'From' },
    { data: 'end_date', title: 'To' },
    { data: 'num_of_days', title: 'Days' },
    { data: 'duration_type', title: 'Duration' },
    { data: 'status', title: 'Status' },
    {
      data: function () {
        return '';
      },
      title: 'Attachment'
    },
    { data: 'status', title: 'Action' }
  ],
  columnDefs: [
    { className: 'dt-center', targets: '_all' },
    { width: '12%', targets: [4, 5] },
    {
      targets: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      createdCell: function(td) {
        $(td).css({
          'font-size': '14px',
          'vertical-align': 'middle',
          'text-transform': 'capitalize'
        });
      }
    },
    {
      target: 0,
      visible: false,
      searchable: false,
    },
    {
      target: 9,
      createdCell: function(td, cellData, rowData) {
        if (rowData.medical_certificate != null) {
          $(td).addClass('mdi mdi-paperclip text-center attachment')
               .css({
                 'font-size': '25px',
                 'cursor': 'pointer'
               });
        }
      }
    },
    {
      target: 10,
      createdCell: function(td, cellData, rowData) {
        var innerHTML = '';
        if (rowData.status == 'pending' || rowData.status == 'Level 1 Approved') {
          if (rowData.leave_type === 'Work From Home' && !(this.whoami == 'leaveadmin' || this.whoami == 'executive' || this.employeeId == 'SG001')) {
            innerHTML = '';
          } else if (this.employeeId == 'ADM01' || this.employeeId == 'SG001') {
            innerHTML = `<div>
                <a class='approve' style="cursor: pointer" @click="approveLeave(leaves)">
                    <span title="Approve" style="font-size: 25px !important;color:orange;" class="mdi mdi-checkbox-outline mr-2"></span>
                </a>
                <a class='reject' style="cursor: pointer" @click="rejectLeave(leaves)">
                    <span title="Reject" style="font-size: 25px !important;color:red;" class="mdi mdi-close-box-outline"></span>
                </a>
            </div>`;
          } else if (this.whoami == "linemanager" && rowData.status == 'Level 1 Approved') {
            innerHTML = `<span class="px-2 m-2 text-center mdi mdi-check-circle"
                          style="font-size: 25px;color: green;"></span>`;
          } else if (this.whoamiLocation.trim() == rowData.location.trim()) {
            if (this.whoami == "linemanager" || this.whoami == "executive" || this.whoami == "leaveadmin") {
              innerHTML = `<div>
                  <a class='approve' style="cursor: pointer" @click="approveLeave(leaves)">
                      <span title="Approve" style="font-size: 25px !important;color:orange;" class="mdi mdi-checkbox-outline mr-2"></span>
                  </a>
                  <a class='reject' style="cursor: pointer" @click="rejectLeave(leaves)">
                      <span title="Reject" style="font-size: 25px !important;color:red;" class="mdi mdi-close-box-outline"></span>
                  </a>
              </div>`;
            }
          } else if (this.whoamiLocation.trim() != rowData.location.trim()) {
            if (this.whoami == "executive" || this.whoami == "leaveadmin" || this.whoami == "linemanager") {
              innerHTML = `<div>
                  <a class='approve' style="cursor: pointer" @click="approveLeave(leaves)">
                      <span title="Approve" style="font-size: 25px !important;color:orange;" class="mdi mdi-checkbox-outline mr-2"></span>
                  </a>
                  <a class='reject' style="cursor: pointer" @click="rejectLeave(leaves)">
                      <span title="Reject" style="font-size: 25px !important;color:red;" class="mdi mdi-close-box-outline"></span>
                  </a>
              </div>`;
            }
          }
        } else if (rowData.status == 'Cancelled') {
          innerHTML = `<span class="px-2 m-2 text-center mdi mdi-cancel"
                        style="font-size: 25px;color: red;"></span>`;
        } else if (role.includes('Leave-Admin') && rowData.status == 'Approved') {
          innerHTML = `<div>
              <a class='revoke' style="cursor: pointer" @click="revokeLeave(leaves)">
                  <span title="Revoke" style="font-size: 25px !important;" class="mdi mdi-arrow-left-bold-box-outline mr-2"></span>
              </a>
              <a class='reject' style="cursor: pointer" @click="rejectLeave(leaves)">
                  <span title="Reject" style="font-size: 25px !important;color:red;" class="mdi mdi-close-box-outline"></span>
              </div>`;
        } else if (rowData.status == 'Rejected' || rowData.status == 'Approved') {
          innerHTML = `<span class="px-2 m-2 text-center mdi mdi-check-circle"
                        style="font-size: 25px;color: green;"></span>`;
        }
        $(td).html(innerHTML);
      }.bind(this)
    }
  ]
});

$('#teamTableDesktop_wrapper .dataTables_length select')
    .css({
        'width': '60px',
        'margin-top':'5px', // Adjust width as needed
    });




      let tempLeavelist = this.allLeaveList.filter( element => this.shouldNotifyLeaveAction(element));
      // console.log('leaveNotifsforteampage: ', [tempLeavelist, this.whoami]);
      if(tempLeavelist.length > 0 ){
        this.showLeaveNotification = true;          
        this.$emit('leaveNotificationCount', tempLeavelist.length);
      } else {
        this.showLeaveNotification = false;          
        this.$emit('leaveNotificationCount', 0);
      }
    }).catch((error) => {
      console.log(error);
    })
    .finally(() => {
      this.loading = false; 
    });
             
  },
  blockedAction() {
    Swal.fire({
      text: "Action to be taken by Leave-Admin, Executive or The MD",
      confirmButtonText: "OK"
    })
  },
  isWfhApprover() {
    return this.whoami === 'leaveadmin' || this.whoami === 'executive' || this.employeeId === 'SG001';
  },
  canActOnPendingLeave(leave) {
    if (leave.leave_type === 'Work From Home') {
      return this.isWfhApprover();
    }
    return true;
  },
  shouldNotifyLeaveAction(element) {
    if (element.leave_type === 'Work From Home') {
      return element.status === 'pending' && this.isWfhApprover();
    }
    return (
      (element.status == 'pending' && (element.reporting_to == this.employeeId || (element.reporting_to == 'SG001' && this.whoami == 'executive'))) ||
      (element.status == 'Level 1 Approved' && (this.whoami == 'executive' || this.employeeId == 'SG001')) ||
      (this.whoami == 'leaveadmin' && (element.status == 'pending' || element.status == 'Level 1 Approved'))
    );
  },
  async approveLeave(data) {
    if (data.leave_type === 'Work From Home' && !this.isWfhApprover()) {
      this.blockedAction();
      return;
    }
    let executionFlag = false;  
    let comments = ''; 

    //  else {
    await Swal.fire({
        html: '<b><span stye="font-size:20px;text-left;">comments:</span></b>',
        input: 'textarea',
        confirmButtonText: 'Approve',
        confirmButtonColor: 'orange',
        showCloseButton: true,
        focusConfirm: false,
      }).then(function(input){
        if(input.value == '' || input.value) {
          comments = input.value;
          executionFlag = true;
        } else {
          return false;
        }
      });
    if (executionFlag) {
      let leaveDetails = {
        empid: data.empid,
        leaveId: data.leave_id,
        totalDays: data.num_of_days,
        leaveType: data.leave_type,
        status: 'Approved',
        comments: comments,
        updatedAt: data.updated_at,
        action_by: this.employeeId,
        // level2Approval: data.level_2_approval,
        // level1Approved: data.level_1_approved,
      };
      if(data.leave_type !== 'Work From Home' && (data.leave_type == 'Emergency Leave' || data.location != this.whoamiLocation) && this.whoami == "linemanager" && this.employeeId !== "SG001" && data.leave_type != 'Sick Leave') {
        // this.blockedAction();
        leaveDetails.status = 'Level 1 Approved';
      }
      this.loading = true;
      axios
        .put(this.$hostName + `/approveAppliedLeave/${data.id}`, {
          leaveDetails: leaveDetails,
          whoami: this.whoami,
        })
        .then((response) => {
          if (response.status == 200) {
            this.mountedFunction();
            Swal.fire('Approved', '', 'success');
          } else if (response.status == 203){
            Swal.fire({
                  text: response.data, 
                  confirmButtonText: 'Ok',
                });
                return; 
          } else {
            Swal.fire({
                  text: 'Something went wrong. Please try again later.', 
                  confirmButtonText: 'Ok',
                });
                return; 
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            text: 'Something went wrong. Please try again later.', 
            confirmButtonText: 'Ok',
          });
          return; 
        })
        .finally(() => {
          this.loading = false;
        });
      }
    // }
  },
  async rejectLeave(data) {
    if (data.leave_type === 'Work From Home' && !this.isWfhApprover()) {
      this.blockedAction();
      return;
    }
    // if(data.location != this.whoamiLocation && this.whoami == "linemanager" && this.employeeId !== "SG001") {
    //   this.blockedAction();
    // } else {
          const { value: textarea } = await Swal.fire({
          html: '<b><span stye="font-size:20px;">comments:</span></b>',
          input: 'textarea',
          confirmButtonText: 'Reject',
          cancelButtonText: 'Cancel',
          confirmButtonColor: 'red',
          showCloseButton: true,
          focusConfirm: false,
          didOpen : function () {
            Swal.getConfirmButton().setAttribute('disabled', '');
            Swal.getInput().addEventListener('keyup', function(e) {
            if(e.target.value === '') {
              Swal.getConfirmButton().setAttribute('disabled', '');
            } else {
              Swal.getConfirmButton().removeAttribute('disabled');
            }
          });
        }  
        });
        if (textarea) {
          this.loading = true;
          let leaveDetails = {
            empid: data.empid,
            leaveId: data.leave_id,
            totalDays: data.num_of_days,
            leaveType: data.leave_type,
            status: 'Rejected',
            comments: textarea,
            updatedAt: data.updated_at,
            whoAmI: this.whoami,
            action_by: this.employeeId
          };
          axios
            .put(this.$hostName + `/approveAppliedLeave/${data.id}`, {
              leaveDetails: leaveDetails,
              whoami: this.whoami,
            })
            .then((response) => {
              if (response.status == 200 || response.status == 'ok' ) {
                this.mountedFunction();
                Swal.fire('Rejected', '', 'success');
              } else if (response.status == 203){
              Swal.fire({
                    text: response.data, 
                    confirmButtonText: 'Ok',
                  });
                  return; 
            } else {
                Swal.fire({
                      text: 'Something went wrong. Please try again later.', 
                      confirmButtonText: 'Ok',
                    });
                    return; 
              }
            })
            .catch((error) => {
              console.log(error);
              Swal.fire({
                text: 'Something went wrong. Please try again later.', 
                confirmButtonText: 'Ok',
              });
              return;
            })
            .finally(() => {
              this.loading = false;
            });
        }
    // }
  },
  async revokeLeave(data) {
    const { value: textarea } = await Swal.fire({
      html: '<b><span stye="font-size:20px;">comments:</span></b>',
      input: 'textarea',
      confirmButtonText: 'Revoke',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'black',
      showCloseButton: true,
      focusConfirm: false,
      didOpen: function () {
        Swal.getConfirmButton().setAttribute('disabled', '');
        Swal.getInput().addEventListener('keyup', function(e) {
        if(e.target.value === '') {
          Swal.getConfirmButton().setAttribute('disabled', '');
        } else {
          Swal.getConfirmButton().removeAttribute('disabled');
        }
      });
    }  
    });
    if (textarea) {
      this.loading = true;
      let leaveDetails = {
        empid: data.empid,
        leaveId: data.leave_id,
        totalDays: data.num_of_days,
        leaveType: data.leave_type,
        status: 'pending',
        comments: textarea,
        updatedAt: data.updated_at,
        whoAmI: this.whoami,
        applied_by: this.employeeId,
        action_by: this.employeeId
      };
      axios
        .put(this.$hostName + `/approveAppliedLeave/${data.id}`, {
          leaveDetails: leaveDetails,
        })
        .then((response) => {
          if (response.status == 200 || response.status == 'ok' ) {
            this.mountedFunction();
            Swal.fire('Revoked', '', 'success');
          } else if (response.status == 203){
          Swal.fire({
                text: response.data, 
                confirmButtonText: 'Ok',
              });
              return; 
        } else {
            Swal.fire({
                  text: 'Something went wrong. Please try again later.', 
                  confirmButtonText: 'Ok',
                });
                return; 
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            text: 'Something went wrong. Please try again later.', 
            confirmButtonText: 'Ok',
          });
          return;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  getReporteesRegion(event){

    // this.reportees =this.reportees 
    // console.log("this.reportees ",this.reportees );
    this.selectedEmpRegion = event.target.value.substr(0,2);
    this.reporteeIndex = event.target.selectedIndex - 1;
    const selectedReportee = this.directreportees[this.reporteeIndex];
    // console.log("Employment type of selected reportee:", selectedReportee.employement_type);

   if (selectedReportee.employement_type !== 'Full Time Employee') {
        this.leaveAdminAppliedLeaveData = this.originalLeaveData.filter(leave =>
            leave.leaveType === 'Annual Leave' || leave.leaveType === 'Unpaid Leave' || leave.leaveType === 'Menstrual Cycle Leave' || leave.leaveType === 'Work From Home'
        )
        .map(leave => ({
            ...leave,
            leaveType: leave.leaveType === 'Annual Leave' ? 'Leave' : leave.leaveType
        }));

        this.filteredManagerAppliedLeaveData = this.appliedLeaveData.filter(leave =>
            leave.leaveType === 'Annual Leave' || leave.leaveType === 'Unpaid Leave' || leave.leaveType === 'Menstrual Cycle Leave' || leave.leaveType === 'Work From Home'
        )
        .map(leave => ({
            ...leave,
            leaveType: leave.leaveType === 'Annual Leave' ? 'Leave' : leave.leaveType
        }));
    } else {
        // Restore full original array
        this.leaveAdminAppliedLeaveData = this.originalLeaveData;
        this.filteredManagerAppliedLeaveData = this.appliedLeaveData;
    }
    
  },
  getLeaveIdByType(type){
    this.leavename = type.split('-')[0].trim();
    // console.log('leave:', this.leavename.trim());
    if(this.leavename == "Optional Public Leave") {
      this.leavename = "Optional Leave";
    }
    this.leavebal = type.split('-')[1];
    axios.post(this.$hostName + '/getleaveid', {
      leaveType: ((this.leavename === 'Leave') ? 'Annual Leave' : this.leavename)+ ' ' + 'Balance'
    }).then((res) =>{
    this.appliedLeaveStatus.leaveid = res.data.empLeaveData.id;
    });
  },
  filterLeavesByRegion(){
    let filteredLeaveType = [];
    let temp = [];
    if(this.whoami == 'leaveadmin') {
      for(let i=0; i<this.leaveAdminAppliedLeaveData.length; i++){
        for(let j=0; j<this.leaveAdminAppliedLeaveData[i].region.length; j++){
          if(this.reporteesLeaveBal[this.reporteeIndex] != undefined){
            if((this.selectedEmpRegion == this.leaveAdminAppliedLeaveData[i].region[j] || this.leaveAdminAppliedLeaveData[i].region[j] == 'All') && (this.directreportees[this.reporteeIndex].gender.toUpperCase() == this.leaveAdminAppliedLeaveData[i].gender || this.leaveAdminAppliedLeaveData[i].gender == 'All')){
              temp.push(this.getBalanceByLeaveType(this.reporteesLeaveBal[this.reporteeIndex].getReporteesLeaveBal,this.leaveAdminAppliedLeaveData[i].leaveType === 'Leave' ? 'Annual Leave' : this.leaveAdminAppliedLeaveData[i].leaveType));
              filteredLeaveType.push(this.leaveAdminAppliedLeaveData[i].leaveType);
            }
          }
        }
      }
    } else {
      for(let i=0; i<this.filteredManagerAppliedLeaveData.length; i++){
        for(let j=0; j<this.filteredManagerAppliedLeaveData[i].region.length; j++){
          if(this.reporteesLeaveBal[this.reporteeIndex] != undefined){
            if(this.selectedEmpRegion == this.filteredManagerAppliedLeaveData[i].region[j] || this.filteredManagerAppliedLeaveData[i].region[j] == 'All'){
              temp.push(this.getBalanceByLeaveType(this.reporteesLeaveBal[this.reporteeIndex].getReporteesLeaveBal,this.leaveAdminAppliedLeaveData[i].leaveType === 'Leave' ? 'Annual Leave' : this.leaveAdminAppliedLeaveData[i].leaveType));
              filteredLeaveType.push(this.filteredManagerAppliedLeaveData[i].leaveType);
            }
          }
        }
      }
    } 
      let finalFilteredData = [];
      for(let k=0; k<filteredLeaveType.length; k++){
          let json = {
            name: '',
            balance: ''
          };
        json.name = filteredLeaveType[k];
        //It has been done this way since National Service Leave initially used to have balance and hence it has balance data in the database unlike Unpaid Leaves
        if(filteredLeaveType[k] != 'National Service Leave') {
          json.balance = temp[k];
        } 
        if(filteredLeaveType[k] == "Optional Leave") {
          json.name = "Optional Public Leave";
          let foundElement = filteredLeaveType.find(ele => ele == "Optional Leave");
          let idx = filteredLeaveType.indexOf(foundElement);
          json.balance = temp[idx];
        }
        finalFilteredData.push(json);
      }
      return finalFilteredData;
  },
  getBalanceByLeaveType(data, name) {
    let leaveArr = {};

    for(let leave in data){
      leaveArr[data[leave].name] = data[leave].balance;
    }

    return leaveArr[name+' Balance'];
  },
    tabSwitch(type){
      var tab1 = document.getElementById('nav-leave-list');
      var btnTab1 = document.getElementById('nav-leave-list-tab');
      var tab2 = document.getElementById('nav-assignedto');
      var btnTab2 = document.getElementById('nav-assignedto-tab');
      if(type == 'leave-list'){
        tab2.classList.remove('show');
        tab2.classList.remove('active');
        btnTab2.classList.remove('active');
        tab1.classList.add('show');
        tab1.classList.add('active');
        btnTab1.classList.add('active');
      } 
      else if(type == 'assignedto'){
        tab1.classList.remove('show');
        tab1.classList.remove('active');
        btnTab1.classList.remove('active');
        tab2.classList.add('show');
        tab2.classList.add('active');
        btnTab2.classList.add('active');
      } 
    },
    downloadAttachment(blobData){
    let type = blobData.split('/')[1];
    let fileTyepe = type.split(';')[0];
    var a = document.createElement('a');
    a.href = blobData;
    a.download = 'attachment.' + fileTyepe; 
    a.click();
  }
    
  },
  

};
</script>
<style scoped>




.file-loader{
  margin-left: 20px;
}
.leave-apply{
  color: #fff;
  font-size: 22px;
  letter-spacing: 0px;
  font-family: 'Montserrat';
  top: 360px;
  left: 30px;
  background-color: red;
  width: 120px;
  height: 36px;
  border: none;
  position: absolute;
}
.leave-cancel{
  color: #fff;
  font-size: 22px;
  letter-spacing: 0px;
  font-family: 'Montserrat';
  top: 360px;
  left: 180px;
  position: absolute;
  background-color: grey;
  width: 120px;
  height: 36px;
  border: none;

}

.auto-check{
  display: inline;
}

.autoApproved{
  margin-left:15%; 
  transform: scale(1.5);
}



/*mobile view start */
@media only screen and (max-width: 575.98px) {

.choose-file{
  margin-top: 20px !important;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0px;
} 
.no-announcement{
  text-align: center;
  position: absolute;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%,-50%) !important;
}
  .approve{
    margin-right:10px !important;
  }

.autoApproved{
  margin-left: 0px !important;
  margin-right: 15px;
}

.desktop-table{
  display: none !important;
  width: 100%;
}

.mobile-table{
  display: block !important;
}

.tab-table{
   display: none !important;
  width: 100%;
}

.leave-holder{
box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
height: 520px !important;
position: relative;
z-index: 20;
overflow: auto;
}

.left-side{
font-family: 'Montserrat';
position: fixed !important;
margin-bottom: 50px;
left: 0% !important;
padding: calc(25vh - 60px) 20px 30px 20px;
height: 100%;
width: calc(100%  ) !important;
}

.left-column{
font-family: 'Montserrat';
position: fixed;
left: 0px !important;
width: calc(100% - 80px) !important;
}


.leave-button1{
padding-left: 2 px;
padding-right: 4px;
font-size: 12px;
}

.leave-button2{
  padding-left: 4px;
  padding-right: 2px;
  font-size: 12px;
}

.big-screen{
display: none !important;
}

.mobile-screen{
display: initial !important;
}

.tab-screen{
display: none !important;

}

.textArea{
width: 90%;
}

.from{
width:90% !important;
}

.to{
width:90% !important;
}

.leave-cancel{
  color: #fff;
  font-size: 22px;
  letter-spacing: 0px;
  font-family: 'Montserrat';
  margin-top: 10px !important;
  margin-left: 10px !important;
  background-color: grey;
  width: 100px !important;
  height: 36px;
  border: none;
  position: static !important;
}

.leave-apply{
  color: #fff;
  font-size: 22px;
  letter-spacing: 0px;
  font-family: 'Montserrat';
  top: 360px;
  left: 30px;
  background-color: red;
  width: 100px !important;
  height: 36px;
  border: none;
  position: static !important;
}


input[type='radio'] {
    -webkit-appearance: none;
    border-radius: 50%;
    outline: none;
    box-shadow: 0 0 0 1px red;
    height: 20px;
    width: 20px;
    margin-top: 5px;
    margin-right: 5px !important;
    margin-left: 5px !important;
}

.leave-container[data-v-72a2780d] {
  position: relative;
  top: -43px;
  z-index: 20;
}

.mobile-auto-approve{
    margin-right: 15px;
    margin-top: 10px;
    margin-left: 0px !important;
    /* transform: scale(1.5); */
}

.leave-list{
box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
overflow : auto;
position: relative;
height: 500px !important;

}

.choose-file-text{
margin-left: 0px !important;
}

.attach-file-text{
position: relative;
top: 30px;
left: -100px;
}


.note-text{
margin-top: 30px;
}
.mobileview-text{
  font-size: 18px;
}
}
/*mobile view end*/


/* Tab view start */

@media (min-width: 768px) and (max-width: 991.98px) {
  .file-loader{
  margin-left: 20px;
}
.no-announcement{
    text-align: center;
    position: absolute;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%,-50%) !important;
}

.autoApproved{
  margin-left: 0px !important;
  margin-top: 20px;
  margin-right: 15px;
}

.auto-check{
  display: block;
}

.approved{
font-size: 40px !important;
}
.rejected{

font-size: 40px !important;

}
.leave-apply{
  color: #fff;
  font-size: 22px;
  letter-spacing: 0px;
  font-family: 'Montserrat';
  top: 370px !important;
  left: 30px;
  background-color: red;
  width: 100px !important;
  height: 36px;
  border: none;
  position: absolute !important;
}

.leave-holder{
  height: 530px !important;
}
.leave-container{
  position: relative;
  top: -50px;
  z-index: 20;
  left: 17px !important;
  width: calc(100% - 30px) !important;
}

.left-column{
  font-family: 'Montserrat';
  position: absolute;
  left: 37px !important;
  margin: 8px 15px 0px 15px;
}

.left-side{
  font-family: 'Montserrat';
  position: absolute;
  margin-bottom: 50px;
  left: 10px !important;
  padding: calc(25vh - 60px) 20px 30px 20px;
  margin-bottom: 50px;
  top: 60px;
  height: 100%;
  width: calc(100% - 10px) !important;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.from{
width:90% !important;
}

.to{
width: 90% !important;

}

.textArea{
width: 90% !important
}

.leave-cancel{
  margin-top: 10px;
  margin-left: 8px !important;
  width: 100px !important;
  height: 36px;
}

input[type='radio'] {
    -webkit-appearance: none;
    border-radius: 50%;
    outline: none;
    box-shadow: 0 0 0 1px red;
    height: 20px;
    width: 20px;
    margin-top: 5px;
    margin-right: 10px !important;
    margin-left: 20px !important;
}

.choose-file{
  margin-top: 35px !important;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0px;
} 

.desktop-table{
  display: none !important;
  width: 100%;
}

.mobile-table{
  display: none !important;
  width: 100%;
}

.tab-table{
   display: block !important;
   min-height: 200px;
}
.tabview-text{
  font-size: 25px !important;
}


}
/*Tab view ends*/

.mobile-table{
  display: none;
  width: 100%;

}


.tab-table{
  display: none ;
  width: 100%;
}

.desktop-table{
  width: 100%;
  min-height: 300px;
}


.mobile-screen{
  display: none;
}

.approve {
background-color: orange;
-webkit-background-clip: border-box;
background-clip: border-box;
text-align: center;
font-weight: bold;
color: #fff;
}
.type-of-leave{
color: #000;
font-size: 20px;
letter-spacing: 0px;
font-family: 'Montserrat';
margin-top: 28px;
}
.manager-name{
color: #000;
font-size: 28px;
letter-spacing: 0px;
font-family: 'Montserrat';
font-weight: bold;
}
.approved{
background-color: green;
-webkit-background-clip: border-box;
background-clip: border-box;
text-align: center;
font-weight: bold;
color: #fff;
}
.rejected{
background-color: red;
-webkit-background-clip: border-box;
background-clip: border-box;
text-align: center;
font-weight: bold;
color: #fff;
}
.leaveModal{
padding: 0px;
}
.upcomingModal{
padding: 0px;
}
.date{
margin-top: 10px;
font-size: 16px;
font-weight: bold;
letter-spacing: 0px;
} 
.leave-duration{
color: #000;
font-size: 18px;
letter-spacing: 0px;
font-family: 'Montserrat';
margin-top: 40px;
}
.selected-leave{
margin-top: 10px;
width: 230px;
} 
.optional-selected-leave{
margin-top: 10px;
/* width: 300px; */

width: 85%;

}
select{
height: 30px;
}
.name{
color: #000;
font-size: 18px;
letter-spacing: 0px;
font-family: 'Montserrat';
margin-top: 10px;
}
.from-date{
color: #000;
font-size: 18px;
letter-spacing: 0px;
font-family: 'Montserrat';
margin-top: 18px;
}
.from{
width: 80%;
}
.to{
width: 80%;
}

.textArea{
width: 90% !important;
}

.reason{
width: 80%;
}
.to-date{
color: #000;
font-size: 18px;
letter-spacing: 0px;
font-family: 'Montserrat';
margin-top: 30px;
}
.leave-reason{
color: #000;
font-size: 18px;
letter-spacing: 0px;
font-family: 'Montserrat';
margin-top: 30px;
}

.leave-duration{
color: #000;
font-size: 22px;
letter-spacing: 0px;
font-family: 'Montserrat';
margin-top: 10px;
}

input[type='radio'] {
    -webkit-appearance: none;
    border-radius: 50%;
    outline: none;
    box-shadow: 0 0 0 1px red;
    height: 20px;
    width: 20px;
    margin-top: 5px;
    margin-right: 10px;
    margin-left: 15px;
}

input[type='radio']:before {
    content: '';
    display: block;
    width: 60%;
    height: 60%;
    margin: 20% auto;
    border-radius: 50%;
}

input[type='radio']:checked:before {
    background: #D05959;
}
.left-side{
font-family: 'Montserrat';
position: absolute;
margin-bottom: 50px;
padding: calc(25vh - 60px) 20px 30px 20px;
margin-bottom: 50px;
top: 60px;
height: 100%;
width: calc(100% - 100px);
-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none; /* Firefox */
}
.left-column{
font-family: 'Montserrat';
position: absolute;
left: 60px;
width: calc(100% - 60px);
margin: 8px 15px 0px 15px;
}

.topBg {
background-image: url(/img/Portal_Banner.7c3ce9a6.png);
height: 25%;
width: 100%;
position: relative;
background-repeat: no-repeat;
background-size: 100% 100%;
background-position: center;
}

.tab-bg{
background-color: #EE3234;
background-position: center;
background-repeat: no-repeat;
background-size: cover;
position: relative;
top: 0px;
color: #fff;
width: 100%;
z-index: 1;
}
.announcementText{
height: 62px;
line-height: 62px;
font-size: 38px;
letter-spacing: 0px;
}
.leave-holder{
z-index: 20;
box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
height: 500px;
position: relative;
}
.leave-container{
position: relative;
top: -50px;
z-index: 20;
left: 60px;
width: calc(100% - 20px);
}

.leave-list{
  box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
  overflow : auto;
  position: relative;
  height: auto;

}
.announcement-scroller{
  overflow-y: scroll;
  scrollbar-width: none;
  height: 497px;
  background-color: white;
  z-index: 20;
}
.announcement-scroller::-webkit-scrollbar {
 display: none;
}

.choose-file-text{
margin-left: 20px;
}

.noAnnouncementImg{
  width: 100px;
}
.no-announcement{
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.choose-file{
  margin-top: 45px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0px;
} 

thead {
  top: 0;
  background: white;
  position: sticky;
}

.formattedStatus {
  text-transform: capitalize !important;
}

</style>